<template>
  <v-container fluid>
    <v-row v-if="loading">
      <v-col cols="12" class="text-center my-10">
        <v-progress-circular
          indeterminate
          color="primary"/>
      </v-col>
    </v-row>
    <v-row v-else-if="pendingOrders.length === 0 && pendingOrderMessage">
      <v-col cols="12">
        {{pendingOrderMessage}}
      </v-col>
    </v-row>
    <v-list dense v-else class="pa-0">
      <v-card class="mb-2" v-for="pendingOrder in pendingOrders" :key="pendingOrder.id">
        <v-row class="pa-1" style="background-color: #B4DBFF;" no-gutters align="center">
          <v-col cols="6">
            <div class="h5">#{{pendingOrder.id}}</div>
          </v-col>
          <v-col class="text-right" cols="4">
<!--            <div class="caption">TEXT</div>-->
          </v-col>
          <v-col class="text-right" cols="2">
<!--            <v-icon>fas fa-sign-out-alt</v-icon>-->
          </v-col>
        </v-row>
        <v-row v-for="order in pendingOrder.list" :key="order.id" no-gutters class="mx-4">
          <v-col>
            <v-row align="start">
              <template v-if="order.state >= 0">
                <v-col cols="8">
                  <div class="subtitle-2 py-0" v-text="order.title"/>
<!--                  <div class="text-left caption" v-for="note in order.notes" :key="note.id" v-text="captionMemo(note)" />-->
                </v-col>
                <v-col cols="4">
                  <div class="text-right font-weight-bold caption">X {{order.amount}}</div>
<!--                  <div class="text-right font-weight-bold caption">£{{(order.totalPrice / 100).toFixed(2)}}</div>-->
<!--                  <div class="text-right font-weight-bold caption">VAT: £{{(order.tax / 100).toFixed(2)}}</div>-->
<!--                  <div class="text-right font-weight-bold caption">Total: £{{(order.finalDue / 100).toFixed(2)}}</div>-->
                </v-col>
              </template>
              <template v-else-if="order.state < 0">
                <v-col cols="8">
                  <div class="subtitle-2 py-0">
                    <strike style="color:red;">
                      <span style="color:gray;">{{order.title}}</span>
                    </strike>
                  </div>
<!--                  <div class="text-left caption" v-for="note in order.notes" :key="note.id" v-text="captionMemo(note)" />-->
                </v-col>
                <v-col cols="4">
                  <div class="text-right font-weight-bold caption">X {{order.amount}}</div>
                  <div class="text-right font-weight-bold caption" style="color:red;">Cancelled</div>
                </v-col>
              </template>
            </v-row>
          </v-col>
        </v-row>
        <v-divider class="ma-0"/>
        <v-row v-if="pendingOrder.notes !== null && pendingOrder.notes.length > 0" no-gutters class="mx-4">
          <v-col>
<!--          <v-list-item-title class="text-left">-->
<!--            ORDER MEMO-->
<!--          </v-list-item-title>-->
<!--            <template v-if="pendingOrder.notes.length > 0">-->
<!--              <div class="text-left caption"  v-for="note in pendingOrder.notes" :key="note.id">{{note.userName}}: {{note.description}}</div>-->
<!--            </template>-->
          </v-col>
        </v-row>
<!--        <bill label="TOTAL PRICE"   :value="pendingOrder.totalPrice"/>-->
<!--        <bill label="VAT"           :value="pendingOrder.tax"/>-->
<!--        <bill label="Due"           :value="pendingOrder.finalDue"/>-->
<!--        <bill label="DC"            :value="pendingOrder.discountAmount" v-if="pendingOrder.discountAmount !== 0"/>-->
        <bill label="DELIVERY DATE" :text="pendingOrder.deliveryDate"/>
<!--        <v-row class="mr-3" dense>-->
<!--          <v-col class="text-right" cols="7">-->
<!--          <div class="font-weight-bold body-2">-->
<!--            TOTAL PRICE-->
<!--          </div>-->
<!--          </v-col>-->
<!--          <v-col class="text-right">-->
<!--          <div class="body-2">-->
<!--            £{{(pendingOrder.totalPrice / 100).toFixed(2)}}-->
<!--          </div>-->
<!--          </v-col>-->
<!--        </v-row>-->
<!--        <v-row>-->
<!--          <v-list-item-title class="text-right">-->
<!--            VAT-->
<!--          </v-list-item-title>-->
<!--          <v-list-item-title class="text-right">-->
<!--            £{{(pendingOrder.tax / 100).toFixed(2)}}-->
<!--          </v-list-item-title>-->
<!--        </v-row>-->
<!--        <v-row>-->
<!--          <v-list-item-title class="text-right">-->
<!--            Due-->
<!--          </v-list-item-title>-->
<!--          <v-list-item-title class="text-right">-->
<!--            £{{(pendingOrder.finalDue / 100).toFixed(2)}}-->
<!--          </v-list-item-title>-->
<!--        </v-row>-->
<!--        <v-list-item v-if="pendingOrder.discountAmount != 0">-->
<!--          <v-list-item-title class="text-right"  style="color:red;">-->
<!--            DC-->
<!--          </v-list-item-title>-->
<!--          <v-list-item-title class="text-right"  style="color:red;">-->
<!--            £{{(pendingOrder.discountAmount / 100).toFixed(2)}}-->
<!--          </v-list-item-title>-->
<!--        </v-list-item>-->
<!--        <v-list-item class="my-0 py-0">-->
<!--          <v-list-item-title class="text-right">-->
<!--            DELIVERY DATE-->
<!--          </v-list-item-title>-->
<!--          <v-list-item-subtitle class="text-right" style="color:black;">-->
<!--            {{pendingOrder.deliveryDate}}-->
<!--          </v-list-item-subtitle>-->
<!--        </v-list-item>-->
      </v-card>
    </v-list>
  </v-container>
</template>

<script>
    import {getOrderList} from "../api/order";
    import Bill from "./Bill";

    export default {
        name: "OrdersPending",
      components: {Bill},
      data() {
          return {
            loading: true,
            pendingOrders:[],
            pendingOrderMessage:null,
          }
        },
        mounted() {
          this.getPendingList();
        },
        beforeDestroy() {
        },
        computed: {
          dateRangeText () {
            return this.dates.join(' ~ ')
          },
        },
        methods: {
          getPendingList:function() {
            this.loading = true

            let query = "stateFrom=0&stateTo=90";
            let self=this;
            getOrderList(query)
            .then(function(data) {
              if(data.success) {
                self.pendingOrders = data.item;
              } else {
                self.pendingOrderMessage = data.message;
              }
            })
              .catch((err) => {})
              .finally(() => {self.loading = false})
          },
          timestampToDate: function (timestamp) {
            let date = new Date(timestamp)

            return date.toISOString().substring(0, 10)
          },
          captionMemo(note){
            return `${note.userName}: ${note.description}`
          }
        }
    }
</script>

<style scoped>
  h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
    margin: 0;
    padding: 0;
  }
  .col {
    padding-top:5px;
    padding-bottom:5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/OrdersPending.vue